const STORAGE_KEY = "screen0_onboarding_analytics_auth";

export function readDashboardAuth(): string | null {
  try {
    return sessionStorage.getItem(STORAGE_KEY);
  } catch {
    return null;
  }
}

export function writeDashboardAuth(secret: string) {
  try {
    sessionStorage.setItem(STORAGE_KEY, secret);
  } catch {
    // Best-effort; user will re-enter on next visit.
  }
}

export function clearDashboardAuth() {
  try {
    sessionStorage.removeItem(STORAGE_KEY);
  } catch {
    // ignore
  }
}

const EXCLUDE_TEST_DEVICE_KEY = "screen0_onboarding_analytics_exclude_test_device";
export const ONBOARDING_ANALYTICS_TEST_DEVICE_ID = "5417416d-6bed-46db-8d79-82caee7fa0ed";

export function readExcludeTestDevice(): boolean {
  try {
    return localStorage.getItem(EXCLUDE_TEST_DEVICE_KEY) === "1";
  } catch {
    return false;
  }
}

export function writeExcludeTestDevice(exclude: boolean) {
  try {
    localStorage.setItem(EXCLUDE_TEST_DEVICE_KEY, exclude ? "1" : "0");
  } catch {
    // ignore
  }
}
